import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // Import Quill's CSS
import SectionTitle from '../SectionTitle/SectionTitle'; // Make sure this is the correct import path

const DescriptionEditor = ({ title, value, onChange, direction, t, onBlur, error, helperText, name, validateOnChange }) => {
  // Custom blur handler for ReactQuill
  const handleQuillBlur = () => {
    const event = {
      target: {
        name: name,
      },
    };
    onBlur(event); // Call Formik's onBlur with the custom event
  };

  // Handle change in ReactQuill and trigger Formik validation
  const handleEditorChange = (value) => {
    onChange(value); // Call the onChange handler passed from Formik
    if (validateOnChange) {
      // Trigger Formik's validation on value change
      onBlur({ target: { name } });
    }
  };

  return (
    <Grid item xs={12} sx={{ direction }}>
      <Box className="form-group" sx={{ height: { md: '200px', xs: '250px' }, position: 'relative' }}>
        <Box sx={{ display: 'flex' }}>
          <SectionTitle
            title={title}
            sx={{
              display: 'flex',
              alignItems: 'center',
              marginBottom: '12px',
              fontSize: '16px',
              fontWeight: 400,
              color: '#000000',
              lineHeight: '16.41px',
            }}
          />
          <Typography
            sx={{
              color: '#CA0B0B',
              fontWeight: 700,
              mt: '-18px',
              ml: direction ? '3px' : undefined, // Adjust margins for RTL
              mr: direction ? undefined : '3px', // Adjust margins for RTL
              fontSize: '20px',
            }}
          >
            *
          </Typography>
        </Box>
        <ReactQuill
          value={value}
          onChange={handleEditorChange} // Trigger handleEditorChange on value change
          placeholder={t.descriptionPlaceholder}
          onBlur={handleQuillBlur} // Use the custom handleQuillBlur
          style={{ height: '120px' }}
        />
        {error && (
          <Typography sx={{ color: '#CA0B0B', fontSize: '14px', mt: '8px' }}>
            {helperText}
          </Typography>
        )}
      </Box>
    </Grid>
  );
};

export default DescriptionEditor;
